import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilterListOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    viewBox="0 0 13 13"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.382 12.215.918 1.768a.589.589 0 0 1-.185-.43c0-.162.061-.303.184-.421a.568.568 0 0 1 .422-.184c.163 0 .306.062.429.185l10.464 10.464a.58.58 0 0 1 .185.421.558.558 0 0 1-.184.414.568.568 0 0 1-.422.183.589.589 0 0 1-.429-.185M10.4 7.6a.586.586 0 0 1-.424-.171.568.568 0 0 1-.176-.424c0-.159.053-.3.158-.422A.552.552 0 0 1 10.4 6.4c.17 0 .313.057.428.171a.575.575 0 0 1 .172.425.587.587 0 0 1-.172.429.576.576 0 0 1-.428.175m-3-3a.586.586 0 0 1-.424-.171.568.568 0 0 1-.176-.424c0-.159.053-.3.158-.422A.552.552 0 0 1 7.4 3.4H12c.17 0 .313.057.428.171a.575.575 0 0 1 .172.425.587.587 0 0 1-.172.429A.576.576 0 0 1 12 4.6zm-1.4 6a.582.582 0 0 1-.428-.171.576.576 0 0 1-.172-.425c0-.17.057-.312.172-.429A.576.576 0 0 1 6 9.4h2c.17 0 .313.057.428.171a.575.575 0 0 1 .172.425.587.587 0 0 1-.172.429A.577.577 0 0 1 8 10.6zm-2.4-3a.582.582 0 0 1-.428-.172A.575.575 0 0 1 3 7.003c0-.169.058-.311.172-.428A.576.576 0 0 1 3.6 6.4h3.15v1.2zM2 4.6a.582.582 0 0 1-.427-.172.575.575 0 0 1-.173-.425c0-.169.058-.311.173-.428A.576.576 0 0 1 2 3.4h1.75v1.2z"
    />
  </svg>
);
export default SvgFilterListOff;
